export default {
  //自定义v-resize指令
  resize: {
    bind(el, binding) {
      let width = '', height = '';

      function get() {
        const style = document.defaultView.getComputedStyle(el);
        if (width != style.width || height != style.height) {
          binding.value();
          // { width, height }
        }
        width = style.width;
        height = style.height;
      }

      el.__vueResize__ = setInterval(get, 200);
    },
    unbind(el) {
      clearInterval(el.__vueResize__);
    },
  }
}